// @flow
import * as React from 'react';
import styled from 'styled-components';
import {isMobile} from './Responsive';

// $FlowFixMe
const images = require.context('../assets/images', true, /^\.\/.*$/, 'sync');
// 'sync' | 'eager' | 'weak' | 'lazy' | 'lazy-once'
// images.keys().forEach(filePath => {
//   console.log(filePath);
// });

export type Props = {
  source: string,
  alt?: string,
};

export default function Image(props: Props): React.Element<any> {
  const {source, alt, ...others} = props;
  const images = useImage(source);
  return <img {...others} src={images.imageAuto} alt={props.alt ?? ''} />;
}

export type PropsBackgroundImage = {
  source: string,
  sourceMobile?: string,
  onClick?: () => void,
};

export const BackgroundImage: React.AbstractComponent<PropsBackgroundImage, any> = React.forwardRef<PropsBackgroundImage, any>(
  (props: PropsBackgroundImage, ref: any) =>  {
  const {source, sourceMobile, onClick, ...others} = props;
  const images = useImage(source);
  return <DivBackground {...others} {...images} ref={ref} onClick={onClick} />
});

// export function BackgroundImage(props: PropsBackgroundImage): React.Element<any> {
//   const {source, onClick, ...others} = props;
//   const images = useImage(source);
//   return <DivBackground {...others} {...images} onClick={onClick} />
// }
const DivBackground = styled.div`
  background-image: url(${(props: any) => props.imageAuto });
  background-size: 100% 100%;
`;

export type PropsButtonImage = {
  source: string,
  sourceMobile?: string,
  onClick?: () => void,
};

export const ButtonImage: React.AbstractComponent<PropsButtonImage, any> = React.forwardRef<PropsButtonImage, any>(
  (props: PropsButtonImage, ref: any) =>  {
  const {source, sourceMobile, onClick, ...others} = props;
  const images = useImage(isMobile() ? (sourceMobile ?? source) : source);
  return <ButtonBackground {...others} image={images.imageAuto} ref={ref} onClick={onClick} />
});

const ButtonBackground = styled.button`
  background-image: url(${(props: any) => props.image });
  background-size: 100% 100%;
`;

export type ImageObject = {
  imageAuto: string | null,
}

function findImageObject(src: string): ImageObject {
  const extIndex = src?.lastIndexOf('.') ?? -1;
  const filename = src?.substring(0, extIndex) ?? "";
  const ext = src?.substring(extIndex + 1, src.length) ?? "";

  const sourceList = [src, `${filename}@2x.${ext}`]; //, `${filename}@3x.${ext}`
  const imageLevelIdx = ext === "svg" ? 0 : getImageLevel() - 1;
  console.assert(imageLevelIdx >= 0 && imageLevelIdx < sourceList.length, "invalid imageset");
  const source = sourceList[imageLevelIdx];
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    console.assert(checkImageExists(source), src);
  }
  return {imageAuto: images(source)}
}

function findSafeImageObject(src: string): ImageObject {
  if(!checkImageExists(src)) {
    return {imageAuto: null};
  }

  return findImageObject(src);
}

export function useImage(src: string): ImageObject {
  const prev = React.useRef(src)
  const [source, setSource] = React.useState(() => findImageObject(prev.current));

  React.useEffect(() => {
    if (src !== prev.current) {
      prev.current = src;
      setSource(findImageObject(prev.current));
    }
  }, [src]);

  return source;
}

export function useSafeImage(src: string): ImageObject {
  const prev = React.useRef(src)
  const [source, setSource] = React.useState(() => findSafeImageObject(prev.current));

  React.useEffect(() => {
    if (src !== prev.current) {
      prev.current = src;
      setSource(findSafeImageObject(prev.current));
    }
  }, [src]);

  return source;
}

export function checkImageExists(src: string): boolean {
  try {
    return images(src) != null;
  }
  catch {
    return false;
  }
}

export function imageExists(src: string): Object {
  try {
    return images(src);
  }
  catch {
    return null;
  }
}

export function getImageLevel() : number {
  if (window.devicePixelRatio > 1.0) {
    return 2; //2x
  } else {
    return 1; //normal
  }
}
